// defs
import { IWidgetData } from 'shared/layouts/DetailsPage/components/Widgets/types';

// uri
import { WIDGET_LISTING } from 'shared/constants/uri';

export const getWidgetListingURL = (productId: string, widget: IWidgetData) => {
  return WIDGET_LISTING.replace('<PRODUCT_ID>', productId).replace(
    '<WIDGET_TYPE>',
    widget.widget_type
  );
};
